/**
 * @generated SignedSource<<a270ac541e3dd114798b4527ce571ea7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AuctionLotStatus = "DRAFT" | "OPEN" | "PAUSED" | "CLOSED" | "CANCELED" | "DELETED" | "%future added value";
export type Currency = "USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY" | "%future added value";
export type ImageVersionTypeName = "thumb" | "small" | "medium" | "large" | "zoom" | "original" | "master" | "placeholder" | "datamatics" | "transparent" | "bgProcessed" | "oldMaster" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CartNav_viewer$data = {
  readonly items?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly pdpURL: string | null;
        readonly serviceId: string | null;
        readonly title: string | null;
        readonly isSold: boolean | null;
        readonly photos: ReadonlyArray<{
          readonly versions: ReadonlyArray<{
            readonly webPath: string | null;
            readonly type: {
              readonly name: ImageVersionTypeName | null;
            } | null;
          } | null> | null;
        } | null> | null;
        readonly pricing: {
          readonly netPrice: {
            readonly amount: number | null;
            readonly currency: Currency | null;
            readonly convertedAmountList: ReadonlyArray<{
              readonly currency: Currency | null;
              readonly amount: number | null;
            } | null> | null;
          } | null;
          readonly salePrice: {
            readonly amount: number | null;
            readonly currency: Currency | null;
            readonly convertedAmountList: ReadonlyArray<{
              readonly currency: Currency | null;
              readonly amount: number | null;
            } | null> | null;
          } | null;
          readonly retailPrice: {
            readonly amount: number | null;
            readonly currency: Currency | null;
            readonly convertedAmountList: ReadonlyArray<{
              readonly currency: Currency | null;
              readonly amount: number | null;
            } | null> | null;
          } | null;
        } | null;
        readonly relevantAuctionLot: {
          readonly status: AuctionLotStatus | null;
          readonly buyItNowPrice: {
            readonly convertedAmountList: ReadonlyArray<{
              readonly currency: Currency | null;
              readonly amount: number | null;
            } | null> | null;
          } | null;
        } | null;
        readonly relevantAuctionSolution: {
          readonly bids: {
            readonly totalResults: number | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly portfolios?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly items: {
          readonly totalResults: number | null;
          readonly edges?: ReadonlyArray<{
            readonly node: {
              readonly item: {
                readonly pdpURL: string | null;
                readonly serviceId: string | null;
                readonly title: string | null;
                readonly isSold: boolean | null;
                readonly photos: ReadonlyArray<{
                  readonly versions: ReadonlyArray<{
                    readonly webPath: string | null;
                    readonly type: {
                      readonly name: ImageVersionTypeName | null;
                    } | null;
                  } | null> | null;
                } | null> | null;
                readonly pricing: {
                  readonly netPrice: {
                    readonly amount: number | null;
                    readonly currency: Currency | null;
                    readonly convertedAmountList: ReadonlyArray<{
                      readonly currency: Currency | null;
                      readonly amount: number | null;
                    } | null> | null;
                  } | null;
                  readonly salePrice: {
                    readonly amount: number | null;
                    readonly currency: Currency | null;
                    readonly convertedAmountList: ReadonlyArray<{
                      readonly currency: Currency | null;
                      readonly amount: number | null;
                    } | null> | null;
                  } | null;
                  readonly retailPrice: {
                    readonly amount: number | null;
                    readonly currency: Currency | null;
                    readonly convertedAmountList: ReadonlyArray<{
                      readonly currency: Currency | null;
                      readonly amount: number | null;
                    } | null> | null;
                  } | null;
                } | null;
                readonly relevantAuctionLot: {
                  readonly status: AuctionLotStatus | null;
                  readonly buyItNowPrice: {
                    readonly convertedAmountList: ReadonlyArray<{
                      readonly currency: Currency | null;
                      readonly amount: number | null;
                    } | null> | null;
                  } | null;
                } | null;
                readonly relevantAuctionSolution: {
                  readonly bids: {
                    readonly totalResults: number | null;
                  } | null;
                } | null;
              } | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "CartNav_viewer";
};
export type CartNav_viewer$key = {
  readonly " $data"?: CartNav_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CartNav_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v4 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "pdpURL",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "serviceId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isSold",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ItemPhoto",
    "kind": "LinkedField",
    "name": "photos",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ItemPhotoVersion",
        "kind": "LinkedField",
        "name": "versions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "webPath",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ImageVersionType",
            "kind": "LinkedField",
            "name": "type",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ItemPricing",
    "kind": "LinkedField",
    "name": "pricing",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FinancialAmount",
        "kind": "LinkedField",
        "name": "netPrice",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "FinancialAmount",
        "kind": "LinkedField",
        "name": "salePrice",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "FinancialAmount",
        "kind": "LinkedField",
        "name": "retailPrice",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "AuctionLot",
    "kind": "LinkedField",
    "name": "relevantAuctionLot",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "FinancialAmount",
        "kind": "LinkedField",
        "name": "buyItNowPrice",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "AuctionSolution",
    "kind": "LinkedField",
    "name": "relevantAuctionSolution",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AuctionBidsConnection",
        "kind": "LinkedField",
        "name": "bids",
        "plural": false,
        "selections": [
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchLocalItems"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchPortfolioItems"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "localItemIds"
    },
    {
      "kind": "RootArgument",
      "name": "userIds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CartNav_viewer",
  "selections": [
    {
      "condition": "fetchLocalItems",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            (v0/*: any*/),
            {
              "kind": "Variable",
              "name": "itemIds",
              "variableName": "localItemIds"
            }
          ],
          "concreteType": "ItemsConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Item",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v6/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1
            },
            {
              "kind": "Literal",
              "name": "portfolioTypes",
              "value": [
                "CART"
              ]
            },
            {
              "kind": "Variable",
              "name": "userIds",
              "variableName": "userIds"
            }
          ],
          "concreteType": "PortfoliosConnection",
          "kind": "LinkedField",
          "name": "portfolios",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PortfoliosEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PortfolioV2",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": [
                        (v0/*: any*/)
                      ],
                      "concreteType": "PortfolioItemsConnection",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": false,
                      "selections": [
                        (v5/*: any*/),
                        {
                          "condition": "fetchPortfolioItems",
                          "kind": "Condition",
                          "passingValue": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "PortfolioItemsEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "PortfolioItemV2",
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "Item",
                                      "kind": "LinkedField",
                                      "name": "item",
                                      "plural": false,
                                      "selections": (v6/*: any*/),
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ]
                        }
                      ],
                      "storageKey": "items(first:3)"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "051fbcb6672daa40dd00a39ea28c5315";

export default node;
